const styles = {
  root: { backgroundColor: '#F8F8F8' },
  container: {
    py: { xs: 4, lg: 8 },
  },
  imageContainer: {
    position: 'relative',
    '& img': {
      borderRadius: 2,
    },

  },
  mainImage: {
    borderRadius: 8,
    margin: '0 auto',
    height: { xs: 200, sm: 400 },
    width: { xs: '100%', sm: 400 },
  },
  categories: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 1,
    alignItems: 'center',
  },

  icon: {
    padding: 1,
    borderRadius: 10,
  },

}
export default styles
